import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Schedule = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Schedule' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,23 L23,23 L23,4 L1,4 L1,23 Z M18,4 L18,0 L18,4 Z M6,4 L6,0 L6,4 Z M1,8.5 L23,8.5 L1,8.5 Z M6,14 C6.55643465,12.6666667 7.38976798,12 8.5,12 C9.7998158,12 10.5,13 10.5,14 C10.5,15 9.5,16 8.5,17 C8.11410094,17.3858991 7.44743428,18.0525657 6.5,19 L6.5,19.5 L11.9045742,19.5 M16.984409,20.5 L17,12 L16.5,12 C16,13.5 14.5,14 13.7573,14' />
  </StyledIcon>
);
